import React from 'react'
import SimpleHeader from '../layouts/SimpleHeader'
import SideMenu from '../layouts/SideMenu'
import MenuWrap from '../components/BurgerMenu/MenuWrap'

const Support = () => {
  return (
    <div id="outer-container" style={{ height: '100%' }}>
      <MenuWrap className="sm:hidden">
        <SideMenu isAuthorized={true}></SideMenu>
      </MenuWrap>
      <div id="page-wrap">
        <div className="flex">
          <SideMenu isAuthorized={true} className="hidden sm:block"></SideMenu>
          <div className="w-full">
            <SimpleHeader />
            <div className="h-[calc(100vh-175px)]" aria-live="polite">
              <div className="flex items-center h-full">
                <div className="grid grid-cols-12 gap-8 w-full">
                  {/* Contact Us row */}

                  <div className="relative col-start-4 col-end-10 h-14">
                    <h1 className="col-start-4 col-end-10 w-[20rem] h-14 rounded-full bg-[#F7FAF7] flex items-center justify-center text-lg font-unbounded text-gray-900">
                      Contact Us
                    </h1>
                    <p className="absolute left-[17rem] top-0 h-14 w-[36rem] rounded-full bg-[#DEE6DD] flex items-center justify-center text-lg text-gray-800">
                      support@metrinome.io
                    </p>
                  </div>

                  {/* Leave feedback row */}

                  <div className="relative col-start-4 col-end-10 h-14">
                    <h1 className="col-start-4 col-end-10 w-[20rem] h-14 rounded-full bg-[#F7FAF7] flex items-center justify-center text-lg font-unbounded text-gray-900">
                      Leave feedback
                    </h1>
                    <p className="absolute left-[17rem] top-0 h-14 w-[36rem] rounded-full bg-[#DEE6DD] flex items-center justify-center text-lg text-gray-800">
                      support@metrinome.io
                    </p>
                  </div>

                  {/* Get Support row */}

                  <div className="relative col-start-4 col-end-10 h-14">
                    <h1 className="col-start-4 col-end-10 w-[20rem] h-14 rounded-full bg-[#F7FAF7] flex items-center justify-center text-lg font-unbounded text-gray-900">
                      Get Support
                    </h1>
                    <p className="absolute left-[17rem] top-0 h-14 w-[36rem] rounded-full bg-[#DEE6DD] flex items-center justify-center text-lg text-gray-800">
                      support@metrinome.io
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
